const isAnswered = (localAnswer) => !!localAnswer;

const getControlName = (questionData) => questionData.get('controlName');
const getProperties = (questionData) => questionData.get('properties');
const getHtml = (questionData) => questionData.get('html');
const getResumedAnswer = (blanksData) => blanksData.get('resumedAnswer');

export {isAnswered, getResumedAnswer, getControlName, getProperties, getHtml}